import PropTypes from 'prop-types';
import React, { memo } from 'react';

import {
  SERVICE_AREA_TYPE,
  SERVICE_AREA_TYPE_LABEL,
} from '@/features/provider-profile/constants';
import PinLocationIcon from 'assets/v2/PinLocationIcon';

import { SERVICE_AREA_TYPE_TAG_PALETTE } from './constants';
import { StyledTag } from './ServiceAreaTypeTag.styles';

const ServiceAreaTypeTag = ({ type, ...props }) => {
  const palette =
    SERVICE_AREA_TYPE_TAG_PALETTE[type] ??
    SERVICE_AREA_TYPE_TAG_PALETTE[SERVICE_AREA_TYPE.REGION];
  const label = SERVICE_AREA_TYPE_LABEL[type] ?? type;

  return (
    <StyledTag
      $palette={palette}
      label={label}
      icon={<PinLocationIcon />}
      {...props}
    />
  );
};

ServiceAreaTypeTag.propTypes = {
  type: PropTypes.oneOf(Object.values(SERVICE_AREA_TYPE)).isRequired,
};

export default memo(ServiceAreaTypeTag);
